import type { DraggablePlayableModel } from "models/app";
import { QueueLane } from "models/app/player/input";

export const isDraggableCurrentLane = (item: DraggablePlayableModel) => {
    if ("lane" in item.playable) {
        if (item.playable.lane === QueueLane.Current) return true;
    }
    return false;
};
